import axios from 'axios';
import { API_URL } from '../config';


export const companyVehiclesList = async (
  token: string,
  { page = 1, pageSize = 50, employee }: { page?: number; pageSize?: number; employee?: number } = {}
) => {
  const res = await axios.get(`${API_URL}/vehicles/`, {
    headers: {
      'Authorization': `${token}`,
    },
    params: { page, page_size: pageSize, ...(employee ? { employee } : {}) },
  });
  return res.data;
};


export const companyVehicleCreate = async (
  token: string,
  data: {
    employee: number;
    license_plate: string;
    vehicle_brand?: string;
    vehicle_type?: string;
    vehicle_motor?: string;
    rate_per_km?: string | number;
    registration_document?: File | Blob;
  }
) => {
  const fd = new FormData();
  fd.append('employee', String(data.employee));
  fd.append('license_plate', data.license_plate);
  if (data.vehicle_brand != null) fd.append('vehicle_brand', data.vehicle_brand);
  if (data.vehicle_type  != null) fd.append('vehicle_type',  data.vehicle_type);
  if (data.vehicle_motor != null) fd.append('vehicle_motor', data.vehicle_motor);
  if (data.rate_per_km   != null) fd.append('rate_per_km',   String(data.rate_per_km));
  if (data.registration_document instanceof File || data.registration_document instanceof Blob) {
    fd.append('registration_document', data.registration_document);
  }

  const res = await axios.post(`${API_URL}/vehicles/`, fd, {
    headers: { 
      Authorization: `${token}`,
      'Content-Type': 'multipart/form-data' 
    },
  });
  return res.data;
};

export const companyVehiclePatch = async (
  token: string,
  id: number,
  patch: Partial<{
    employee: number;
    license_plate: string;
    vehicle_brand: string;
    vehicle_type: string;
    vehicle_motor: string;
    rate_per_km: string | number;
    registration_document: File | Blob;
  }>
) => {
  const fd = new FormData();
  if (patch.employee !== undefined)        fd.append('employee', String(patch.employee));
  if (patch.license_plate !== undefined)   fd.append('license_plate', patch.license_plate!);
  if (patch.vehicle_brand !== undefined)   fd.append('vehicle_brand', patch.vehicle_brand!);
  if (patch.vehicle_type !== undefined)    fd.append('vehicle_type',  patch.vehicle_type!);
  if (patch.vehicle_motor !== undefined)   fd.append('vehicle_motor', patch.vehicle_motor!);
  if (patch.rate_per_km !== undefined)     fd.append('rate_per_km',   String(patch.rate_per_km));
  if (patch.registration_document instanceof File || patch.registration_document instanceof Blob) {
    fd.append('registration_document', patch.registration_document);
  }

  const res = await axios.patch(`${API_URL}/vehicles/${id}/`, fd, {
    headers: { 
      Authorization: `${token}`,
      'Content-Type': 'multipart/form-data' 
    },
  });
  return res.data;
};

export const companyVehicleDelete = async (token: string, id: number) => {
  const res = await axios.delete(`${API_URL}/vehicles/${id}/`, {
    headers: {
      'Authorization': `${token}`,
    },
  });
  return res.data;
};